import React from "react";
import { Table, Divider, Popconfirm, Typography } from "antd";
import { withRouter } from "react-router-dom";

const { Text } = Typography;

const ServiceScheduleTable = ({
  pagination,
  dataSource,
  openModal,
  spinner,
  delete: deleteData,
  history,
  modify,
  deleteAccess,
}) => {
  const columns = [
    {
      title: "Model Code(s)",
      dataIndex: "modelCodes",
      key: "modelCodes",
      width: "50%",
      render: (codes, record) => {
        const codeList =
          Array.isArray(codes) && codes.length > 0
            ? codes
            : record.baseModel
            ? record.baseModel.split(",").map((s) => s.trim()).filter(Boolean)
            : [];

        if (codeList.length === 0) return <span>-</span>;

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {codeList.map((code) => (
              <span
                key={code}
                style={{
                  background: "#e6f7ff",
                  border: "1px solid #91d5ff",
                  color: "#096dd9",
                  borderRadius: "4px",
                  padding: "1px 6px",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                {code}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: "Warranty (Days)",
      dataIndex: "warrantyDays",
      key: "warrantyDays",
      width: "13%",
      render: (days) => <span>{days ? `${days} Days` : "-"}</span>,
    },
    {
      title: "Warranty (KMs)",
      dataIndex: "warrantyKm",
      key: "warrantyKm",
      width: "13%",
      render: (km) => <span>{km ? `${km} KMs` : "-"}</span>,
    },
    {
      title: "No. of Services",
      dataIndex: "noOfServices",
      key: "noOfServices",
      width: "12%",
      render: (text) => <span>{text || 0}</span>,
    },
    {
      title: "Action",
      key: "action",
      width: "12%",
      render: (record) => (
        <div>
          {modify ? (
            <span
              className="linkylink"
              onClick={(event) => {
                event.stopPropagation();
                openModal(record, true);
              }}
            >
              Modify
            </span>
          ) : null}
          {deleteAccess ? (
            <Popconfirm
              title={`Are you sure you want to delete ${record.baseModel}?`}
              okText="Yes"
              cancelText="No"
              onCancel={(event) => event.stopPropagation()}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(record.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
                {modify ? <Divider type="vertical" /> : null}
                Delete
              </span>
            </Popconfirm>
          ) : null}
          {!modify && !deleteAccess ? (
            <Text strong disabled>
              No Actions Given
            </Text>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <Table
      loading={spinner}
      dataSource={dataSource}
      columns={columns}
      pagination={pagination}
      rowKey={(record) => record.id}
      style={{ cursor: "pointer" }}
      onRow={(record) => ({
        onClick: () => openModal(record, false),
      })}
    />
  );
};

export default withRouter(ServiceScheduleTable);
